export enum ProjetoComissaoTipo {
  VALOR_FIXO = 'VALOR_FIXO',
  VALOR_PERCENTUAL = 'VALOR_PERCENTUAL',
}
